<template>
  <div class="sky-change-item-detail wsp-padding-left-12">
    <div class="sky-page-content">
      <div>
        <div>
          <div class="wsp-sub-group-title">
            <div class="wsp-group-sub-title-icon"></div>
            <div class="wsp-group-sub-title-value">
              <span style="color: chocolate;"
                >温馨提示：以下是【{{ industryName }}】行业，使用资源配置器前参考文档</span
              >
            </div>
          </div>
          <div>
            <div v-for="(item, index) in qy_notice_images" :key="index">
              <img :src="item" style="width: 100%;" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="text-align: center; margin-top: 10px;">
      <el-button class="el-button filter-item el-button--default el-button--mini" @click="onCancel" size="mini"
        >返回</el-button
      >
    </div>
  </div>
</template>
<script>
import { Button, Card, Table, TableColumn, Tag, Select, Option } from 'element-ui'

import { SkIconStatus } from 'sk-ui'

export default {
  name: 'SkyShowUseCalNotice',
  components: {
    [Card.name]: Card,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tag.name]: Tag,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    [SkIconStatus.name]: SkIconStatus
  },
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data: function() {
    return {
      industryName: '企业',
      qy_notice_images: [
        require('@/assets/images/qy_doc/QY_1.png'),
        require('@/assets/images/qy_doc/QY_2.png'),
        require('@/assets/images/qy_doc/QY_3.png'),
        require('@/assets/images/qy_doc/QY_4.png'),
        require('@/assets/images/qy_doc/QY_5.png')
      ]
    }
  },
  mounted() {},
  methods: {
    onCancel() {
      this.$emit('cb')
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(change-item-detail) {
  ::-webkit-scrollbar {
    width: 3px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 3px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #cccccc;
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: #999999;
  }
  .title-tip {
    font-weight: bold;
    color: red;
  }
  .sky-page-content {
    overflow-y: scroll;
    height: 75vh;
  }
  .page-content-loading {
    padding-left: 20px;
    padding-top: 20px;
  }
  .table-detail-content {
    .cell {
      word-break: break-all;
      white-space: break-spaces;
    }
    .cell-before-data {
      .cell {
        text-decoration: line-through;
      }
    }
  }
  .el-table__body-wrapper .full-value-content {
    padding: 0 !important;
  }
  .el-table__body-wrapper .full-value-content .cell {
    padding: 0 !important;
    min-height: 33px !important;
    .full-content {
      width: 100%;
      height: 100%;
    }
  }
  .page-content-item {
    padding-left: 18px;
  }
  .poc-scene-research-content {
    .scene-item {
      .scene-item-name {
        line-height: 28px;
        border-radius: 6px;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
        padding: 2px 18px;
      }
    }
  }
  .poc-base-detail-content {
    line-height: 28px;
    .base-detail-attr-item div {
      display: inline-block;
    }
    .base-detail-attr-item .attr-label {
      text-align: right;
    }
  }
}
</style>
